/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: ad48843a4a6c6fad4ccd651c7f1a4d85c4ea49f94e19cc7009795d265286c493 */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBuildingByBuildingId: build.query<
      GetBuildingByBuildingIdApiResponse,
      GetBuildingByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Building/${queryArg.buildingId}`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getBuildingClientByClientIdBuildingtypes: build.query<
      GetBuildingClientByClientIdBuildingtypesApiResponse,
      GetBuildingClientByClientIdBuildingtypesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Building/client/${queryArg.clientId ?? ':clientId'}/buildingtypes`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getBuildingForClientByClientId: build.query<
      GetBuildingForClientByClientIdApiResponse,
      GetBuildingForClientByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Building/for-client/${queryArg.clientId ?? ':clientId'}`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getBuildingByBuildingIdUnits: build.query<
      GetBuildingByBuildingIdUnitsApiResponse,
      GetBuildingByBuildingIdUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Building/${queryArg.buildingId}/units`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    postBuildingClientByClientId: build.query<
      PostBuildingClientByClientIdApiResponse,
      PostBuildingClientByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Building/client/${queryArg.clientId ?? ':clientId'}`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.buildingQueryModel,
      }),
    }),
    postClientByClientIdExportExcel: build.mutation<
      PostClientByClientIdExportExcelApiResponse,
      PostClientByClientIdExportExcelApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/export/excel`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.exportRequestModel,
      }),
    }),
    getClientByClientIdQueryextensions: build.query<
      GetClientByClientIdQueryextensionsApiResponse,
      GetClientByClientIdQueryextensionsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/queryextensions`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getClientByClientIdAddresses: build.query<
      GetClientByClientIdAddressesApiResponse,
      GetClientByClientIdAddressesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/addresses`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getClientByClientIdExportMetadata: build.query<
      GetClientByClientIdExportMetadataApiResponse,
      GetClientByClientIdExportMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/export/metadata`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    postClientByClientIdTenants: build.query<
      PostClientByClientIdTenantsApiResponse,
      PostClientByClientIdTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/tenants`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.tenantQueryModel,
      }),
    }),
    postClientByClientIdUnits: build.query<
      PostClientByClientIdUnitsApiResponse,
      PostClientByClientIdUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/units`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.unitQueryModel,
      }),
    }),
    postClientByClientIdUsers: build.mutation<
      PostClientByClientIdUsersApiResponse,
      PostClientByClientIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Client/${queryArg.clientId ?? ':clientId'}/users`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.unitUsersQueryModel,
      }),
    }),
    getNavneregisterThirdpartyinformationByIdDownload: build.query<
      GetNavneregisterThirdpartyinformationByIdDownloadApiResponse,
      GetNavneregisterThirdpartyinformationByIdDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Navneregister/thirdpartyinformation/${queryArg.id}/download`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getNavneregisterInvoicesByInvoiceIdFile: build.query<
      GetNavneregisterInvoicesByInvoiceIdFileApiResponse,
      GetNavneregisterInvoicesByInvoiceIdFileApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Navneregister/invoices/${queryArg.invoiceId}/file`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getNavneregisterInvoices: build.query<
      GetNavneregisterInvoicesApiResponse,
      GetNavneregisterInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Navneregister/invoices`,
        headers: { 'x-api-version': '2.0' },
        params: {
          fromInvoiceDate: queryArg.fromInvoiceDate,
        },
      }),
    }),
    getNavneregisterUnits: build.query<
      GetNavneregisterUnitsApiResponse,
      GetNavneregisterUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Navneregister/units`,
        headers: { 'x-api-version': '2.0' },
        params: {
          includeTenantUnits: queryArg.includeTenantUnits,
          includeCoResidentUnits: queryArg.includeCoResidentUnits,
        },
      }),
    }),
    getNavneregisterThirdpartyinformation: build.query<
      GetNavneregisterThirdpartyinformationApiResponse,
      GetNavneregisterThirdpartyinformationApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Navneregister/thirdpartyinformation`,
        headers: { 'x-api-version': '2.0' },
        params: {
          unitId: queryArg.unitId,
          year: queryArg.year,
        },
      }),
    }),
    getUnitRelationtypes: build.query<
      GetUnitRelationtypesApiResponse,
      GetUnitRelationtypesApiArg
    >({
      query: () => ({
        url: `/hu/Unit/relationtypes`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdAdditionalinfo: build.query<
      GetUnitByIdAdditionalinfoApiResponse,
      GetUnitByIdAdditionalinfoApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/additionalinfo`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    postUnitByIdCoowners: build.mutation<
      PostUnitByIdCoownersApiResponse,
      PostUnitByIdCoownersApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/coowners`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
      }),
    }),
    getUnitByIdIsaffiliated: build.query<
      GetUnitByIdIsaffiliatedApiResponse,
      GetUnitByIdIsaffiliatedApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/isaffiliated`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdHascoownerprocess: build.query<
      GetUnitByIdHascoownerprocessApiResponse,
      GetUnitByIdHascoownerprocessApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/hascoownerprocess`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    postUnitByIdResidents: build.mutation<
      PostUnitByIdResidentsApiResponse,
      PostUnitByIdResidentsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/residents`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.coResidentCreateModel,
      }),
    }),
    getUnitByIdResidents: build.query<
      GetUnitByIdResidentsApiResponse,
      GetUnitByIdResidentsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/residents`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    deleteUnitByIdResidentsAndCoResidencyId: build.mutation<
      DeleteUnitByIdResidentsAndCoResidencyIdApiResponse,
      DeleteUnitByIdResidentsAndCoResidencyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/residents/${queryArg.coResidencyId}`,
        headers: { 'x-api-version': '2.0' },
        method: 'DELETE',
      }),
    }),
    putUnitByIdResidentsAndCoResidencyId: build.mutation<
      PutUnitByIdResidentsAndCoResidencyIdApiResponse,
      PutUnitByIdResidentsAndCoResidencyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/residents/${queryArg.coResidencyId}`,
        headers: { 'x-api-version': '2.0' },
        method: 'PUT',
        body: queryArg.coResidentUpdateModel,
      }),
    }),
    getUnitByIdInvoicesAndInvoiceIdFile: build.query<
      GetUnitByIdInvoicesAndInvoiceIdFileApiResponse,
      GetUnitByIdInvoicesAndInvoiceIdFileApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/invoices/${queryArg.invoiceId}/file`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdOwners: build.query<
      GetUnitByIdOwnersApiResponse,
      GetUnitByIdOwnersApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/owners`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitById: build.query<GetUnitByIdApiResponse, GetUnitByIdApiArg>({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdAnnualcycle: build.query<
      GetUnitByIdAnnualcycleApiResponse,
      GetUnitByIdAnnualcycleApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/annualcycle`,
        headers: { 'x-api-version': '2.0' },
        params: {
          year: queryArg.year,
        },
      }),
    }),
    getUnitByIdMeters: build.query<
      GetUnitByIdMetersApiResponse,
      GetUnitByIdMetersApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/meters`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdNotes: build.query<
      GetUnitByIdNotesApiResponse,
      GetUnitByIdNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/notes`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    putUnitByIdNotes: build.mutation<
      PutUnitByIdNotesApiResponse,
      PutUnitByIdNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/notes`,
        headers: { 'x-api-version': '2.0' },
        method: 'PUT',
        body: queryArg.noteUpdateModel,
      }),
    }),
    getUnitByIdObjects: build.query<
      GetUnitByIdObjectsApiResponse,
      GetUnitByIdObjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/objects`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdProxyowner: build.query<
      GetUnitByIdProxyownerApiResponse,
      GetUnitByIdProxyownerApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/proxyowner`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdInvoices: build.query<
      GetUnitByIdInvoicesApiResponse,
      GetUnitByIdInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/invoices`,
        headers: { 'x-api-version': '2.0' },
        params: {
          invoiceTypeId: queryArg.invoiceTypeId,
          fromInvoiceDate: queryArg.fromInvoiceDate,
        },
      }),
    }),
    getUnitByIdJointcost: build.query<
      GetUnitByIdJointcostApiResponse,
      GetUnitByIdJointcostApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/jointcost`,
        headers: { 'x-api-version': '2.0' },
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
        },
      }),
    }),
    getUnitByIdJointcostpersonal: build.query<
      GetUnitByIdJointcostpersonalApiResponse,
      GetUnitByIdJointcostpersonalApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/jointcostpersonal`,
        headers: { 'x-api-version': '2.0' },
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
          isBoardPortal: queryArg.isBoardPortal,
        },
      }),
    }),
    getUnitChangecoownerparameters: build.query<
      GetUnitChangecoownerparametersApiResponse,
      GetUnitChangecoownerparametersApiArg
    >({
      query: () => ({
        url: `/hu/Unit/changecoownerparameters`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitByIdOwnersHistorical: build.query<
      GetUnitByIdOwnersHistoricalApiResponse,
      GetUnitByIdOwnersHistoricalApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.id}/owners/historical`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getUnitIsssnvalidBySsn: build.query<
      GetUnitIsssnvalidBySsnApiResponse,
      GetUnitIsssnvalidBySsnApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/isssnvalid/${queryArg.ssn}`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    getSiteSiteBySiteId: build.query<
      GetSiteSiteBySiteIdApiResponse,
      GetSiteSiteBySiteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Site/site/${queryArg.siteId}`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
    postSiteClientByClientId: build.mutation<
      PostSiteClientByClientIdApiResponse,
      PostSiteClientByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Site/client/${queryArg.clientId ?? ':clientId'}`,
        headers: { 'x-api-version': '2.0' },
        method: 'POST',
        body: queryArg.siteQueryModel,
      }),
    }),
    getUnitByUnitIdTenants: build.query<
      GetUnitByUnitIdTenantsApiResponse,
      GetUnitByUnitIdTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.unitId}/tenants`,
        headers: { 'x-api-version': '2.0' },
        params: {
          includeFutureTenants: queryArg.includeFutureTenants,
        },
      }),
    }),
    putUnitByUnitIdTenants: build.mutation<
      PutUnitByUnitIdTenantsApiResponse,
      PutUnitByUnitIdTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.unitId}/tenants`,
        headers: { 'x-api-version': '2.0' },
        method: 'PUT',
        body: queryArg.tenantsUpdateModel,
      }),
    }),
    getUnitByUnitIdTenantsHistorical: build.query<
      GetUnitByUnitIdTenantsHistoricalApiResponse,
      GetUnitByUnitIdTenantsHistoricalApiArg
    >({
      query: (queryArg) => ({
        url: `/hu/Unit/${queryArg.unitId}/tenants/historical`,
        headers: { 'x-api-version': '2.0' },
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as hu }
export type GetBuildingByBuildingIdApiResponse =
  /** status 200 OK */ BuildingDetail
export type GetBuildingByBuildingIdApiArg = {
  /** The building id */
  buildingId: number
}
export type GetBuildingClientByClientIdBuildingtypesApiResponse =
  /** status 200 OK */ BuildingClientClientIdBuildingtypesGet200TextPlainResponse
export type GetBuildingClientByClientIdBuildingtypesApiArg = {
  clientId?: string
}
export type GetBuildingForClientByClientIdApiResponse =
  /** status 200 OK */ BuildingForClientClientIdGet200TextPlainResponse
export type GetBuildingForClientByClientIdApiArg = {
  /** The client id */
  clientId?: string
}
export type GetBuildingByBuildingIdUnitsApiResponse =
  /** status 200 OK */ HousingUnitsReturnModelRead
export type GetBuildingByBuildingIdUnitsApiArg = {
  /** The building id */
  buildingId: number
}
export type PostBuildingClientByClientIdApiResponse =
  /** status 200 OK */ BuildingClientClientIdPost200TextPlainResponse
export type PostBuildingClientByClientIdApiArg = {
  /** The client id */
  clientId?: string
  buildingQueryModel: BuildingQueryModel
}
export type PostClientByClientIdExportExcelApiResponse =
  /** status 200 OK */ ClientClientIdExportExcelPost200TextPlainResponse
export type PostClientByClientIdExportExcelApiArg = {
  clientId?: string
  exportRequestModel: ExportRequestModel
}
export type GetClientByClientIdQueryextensionsApiResponse =
  /** status 200 OK */ ClientClientIdQueryextensionsGet200TextPlainResponse
export type GetClientByClientIdQueryextensionsApiArg = {
  clientId?: string
}
export type GetClientByClientIdAddressesApiResponse =
  /** status 200 OK */ ClientClientIdAddressesGet200TextPlainResponseRead
export type GetClientByClientIdAddressesApiArg = {
  clientId?: string
}
export type GetClientByClientIdExportMetadataApiResponse =
  /** status 200 OK */ UnitExportSelectionModel
export type GetClientByClientIdExportMetadataApiArg = {
  clientId?: string
}
export type PostClientByClientIdTenantsApiResponse =
  /** status 200 OK */ TenantQuerySingleResultQueryResultRead
export type PostClientByClientIdTenantsApiArg = {
  clientId?: string
  tenantQueryModel: TenantQueryModel
}
export type PostClientByClientIdUnitsApiResponse =
  /** status 200 OK */ UnitQuerySingleResultQueryResultRead
export type PostClientByClientIdUnitsApiArg = {
  clientId?: string
  unitQueryModel: UnitQueryModel
}
export type PostClientByClientIdUsersApiResponse =
  /** status 200 OK */ ClientClientIdUsersPost200TextPlainResponse
export type PostClientByClientIdUsersApiArg = {
  clientId?: string
  unitUsersQueryModel: UnitUsersQueryModel
}
export type GetNavneregisterThirdpartyinformationByIdDownloadApiResponse =
  /** status 200 OK */ NavneregisterThirdpartyinformationIdDownloadGet200TextPlainResponse
export type GetNavneregisterThirdpartyinformationByIdDownloadApiArg = {
  /** Id of the third party information
   *Tredjepartsinformasjon id (ligningsoppgave id)* */
  id: number
}
export type GetNavneregisterInvoicesByInvoiceIdFileApiResponse =
  /** status 200 OK */ NavneregisterInvoicesInvoiceIdFileGet200TextPlainResponse
export type GetNavneregisterInvoicesByInvoiceIdFileApiArg = {
  /** Invoice id */
  invoiceId: number
}
export type GetNavneregisterInvoicesApiResponse =
  /** status 200 OK */ NavneregisterInvoicesGet200TextPlainResponse
export type GetNavneregisterInvoicesApiArg = {
  /** Invoice Date From - Default 3 years back */
  fromInvoiceDate?: string
}
export type GetNavneregisterUnitsApiResponse =
  /** status 200 OK */ HousingUnitRoleReturnModelRead
export type GetNavneregisterUnitsApiArg = {
  /** Set to true if request should include units where current user is tenant */
  includeTenantUnits?: boolean
  /** Set to true if request should include units where current user is coresident */
  includeCoResidentUnits?: boolean
}
export type GetNavneregisterThirdpartyinformationApiResponse =
  /** status 200 OK */ NavneregisterThirdpartyinformationGet200TextPlainResponseRead
export type GetNavneregisterThirdpartyinformationApiArg = {
  /** Id of the unit */
  unitId?: string
  /** Third party information year (ligningsår) */
  year?: number
}
export type GetUnitRelationtypesApiResponse =
  /** status 200 OK */ UnitRelationtypesGet200TextPlainResponse
export type GetUnitRelationtypesApiArg = void
export type GetUnitByIdAdditionalinfoApiResponse =
  /** status 200 OK */ UnitIdAdditionalinfoGet200TextPlainResponse
export type GetUnitByIdAdditionalinfoApiArg = {
  id: string
}
export type PostUnitByIdCoownersApiResponse = unknown
export type PostUnitByIdCoownersApiArg = {
  /** Unit id */
  id: string
}
export type GetUnitByIdIsaffiliatedApiResponse =
  /** status 200 OK */ UnitIdIsaffiliatedGet200TextPlainResponse
export type GetUnitByIdIsaffiliatedApiArg = {
  id: string
}
export type GetUnitByIdHascoownerprocessApiResponse =
  /** status 200 OK */ UnitIdHascoownerprocessGet200TextPlainResponse
export type GetUnitByIdHascoownerprocessApiArg = {
  id: string
}
export type PostUnitByIdResidentsApiResponse = unknown
export type PostUnitByIdResidentsApiArg = {
  /** Unit id */
  id: string
  coResidentCreateModel: CoResidentCreateModel
}
export type GetUnitByIdResidentsApiResponse =
  /** status 200 OK */ UnitIdResidentsGet200TextPlainResponse
export type GetUnitByIdResidentsApiArg = {
  /** Unit id */
  id: string
}
export type DeleteUnitByIdResidentsAndCoResidencyIdApiResponse = unknown
export type DeleteUnitByIdResidentsAndCoResidencyIdApiArg = {
  /** Unit id */
  id: string
  /** Co-residency id */
  coResidencyId: string
}
export type PutUnitByIdResidentsAndCoResidencyIdApiResponse = unknown
export type PutUnitByIdResidentsAndCoResidencyIdApiArg = {
  /** Unit id */
  id: string
  /** Co-residency id */
  coResidencyId: string
  coResidentUpdateModel: CoResidentUpdateModel
}
export type GetUnitByIdInvoicesAndInvoiceIdFileApiResponse =
  /** status 200 OK */ UnitIdInvoicesInvoiceIdFileGet200TextPlainResponse
export type GetUnitByIdInvoicesAndInvoiceIdFileApiArg = {
  /** The Unit Id */
  id: string
  /** Invoice id */
  invoiceId: number
}
export type GetUnitByIdOwnersApiResponse =
  /** status 200 OK */ UnitIdOwnersGet200TextPlainResponse
export type GetUnitByIdOwnersApiArg = {
  id: string
}
export type GetUnitByIdApiResponse = /** status 200 OK */ UnitRead
export type GetUnitByIdApiArg = {
  /** Id of the unit */
  id: string
}
export type GetUnitByIdAnnualcycleApiResponse =
  /** status 200 OK */ AnnualCycleModel
export type GetUnitByIdAnnualcycleApiArg = {
  /** The unit Id */
  id: string
  /** The year */
  year?: number
}
export type GetUnitByIdMetersApiResponse =
  /** status 200 OK */ UnitIdMetersGet200TextPlainResponse
export type GetUnitByIdMetersApiArg = {
  /** The Unit Id */
  id: string
}
export type GetUnitByIdNotesApiResponse = /** status 200 OK */ UnitBoardDetails
export type GetUnitByIdNotesApiArg = {
  id: string
}
export type PutUnitByIdNotesApiResponse = unknown
export type PutUnitByIdNotesApiArg = {
  id: string
  noteUpdateModel: NoteUpdateModel
}
export type GetUnitByIdObjectsApiResponse =
  /** status 200 OK */ UnitIdObjectsGet200TextPlainResponse
export type GetUnitByIdObjectsApiArg = {
  /** The Unit Id */
  id: string
}
export type GetUnitByIdProxyownerApiResponse =
  /** status 200 OK */ UnitIdProxyownerGet200TextPlainResponse
export type GetUnitByIdProxyownerApiArg = {
  id: string
}
export type GetUnitByIdInvoicesApiResponse =
  /** status 200 OK */ UnitIdInvoicesGet200TextPlainResponse
export type GetUnitByIdInvoicesApiArg = {
  /** The Unit Id */
  id: string
  /** Invoice Type Id */
  invoiceTypeId?: string
  /** Invoice Date From - default one year back */
  fromInvoiceDate?: string
}
export type GetUnitByIdJointcostApiResponse =
  /** status 200 OK */ UnitIdJointcostGet200TextPlainResponse
export type GetUnitByIdJointcostApiArg = {
  /** The Unit Id */
  id: string
  /** Date from */
  fromDate?: string
  /** Date to */
  toDate?: string
}
export type GetUnitByIdJointcostpersonalApiResponse =
  /** status 200 OK */ UnitIdJointcostpersonalGet200TextPlainResponse
export type GetUnitByIdJointcostpersonalApiArg = {
  /** The Unit Id */
  id: string
  /** Date from */
  fromDate?: string
  /** Date to */
  toDate?: string
  /** Use false from a my page portal. Use true from a board member portal. */
  isBoardPortal?: boolean
}
export type GetUnitChangecoownerparametersApiResponse =
  /** status 200 OK */ CoOwnerParametersModel
export type GetUnitChangecoownerparametersApiArg = void
export type GetUnitByIdOwnersHistoricalApiResponse =
  /** status 200 OK */ UnitIdOwnersHistoricalGet200TextPlainResponse
export type GetUnitByIdOwnersHistoricalApiArg = {
  /** Unit id */
  id: string
}
export type GetUnitIsssnvalidBySsnApiResponse =
  /** status 200 OK */ UnitIsssnvalidSsnGet200TextPlainResponse
export type GetUnitIsssnvalidBySsnApiArg = {
  ssn: string
}
export type GetSiteSiteBySiteIdApiResponse = /** status 200 OK */ SiteDetail
export type GetSiteSiteBySiteIdApiArg = {
  /** Id of site */
  siteId: number
}
export type PostSiteClientByClientIdApiResponse =
  /** status 200 OK */ SiteClientClientIdPost200TextPlainResponse
export type PostSiteClientByClientIdApiArg = {
  /** The client id */
  clientId?: string
  siteQueryModel: SiteQueryModel
}
export type GetUnitByUnitIdTenantsApiResponse =
  /** status 200 OK */ UnitUnitIdTenantsGet200TextPlainResponse
export type GetUnitByUnitIdTenantsApiArg = {
  unitId: string
  /** Includes tenants whose tenancy has not started yet. */
  includeFutureTenants?: boolean
}
export type PutUnitByUnitIdTenantsApiResponse = unknown
export type PutUnitByUnitIdTenantsApiArg = {
  unitId: string
  tenantsUpdateModel: TenantsUpdateModel
}
export type GetUnitByUnitIdTenantsHistoricalApiResponse =
  /** status 200 OK */ UnitUnitIdTenantsHistoricalGet200TextPlainResponse
export type GetUnitByUnitIdTenantsHistoricalApiArg = {
  unitId: string
}
export type BuildingAddressModel = {
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** Address country */
  country?: string | null
  /** Country code */
  countryCode?: string | null
  /** Address municipality */
  city?: string | null
  /** Address id */
  addressId?: number | null
}
export type BuildingDetail = {
  /** Id of the building
   *Id på bygning* */
  id?: number
  /** Name of the building
   *Bygningsnavn* */
  name?: string | null
  /** Building type
   *Bygningstype* */
  buildingType?: string | null
  /** Building code
   *Bygningskode* */
  buildingCode?: string | null
  /** Addresses for a building */
  addresses?: BuildingAddressModel[] | null
  /** Number of units in building (andeler) */
  numberOfUnits?: number | null
  /** Number of balconies in the building.
   *Antall balkonger i bygningen* */
  numberOfBalconys?: number | null
  /** Number of fire balconies in the building.
   *Antall brannbalkonger i bygningen* */
  numberOfFireBalconys?: number | null
  /** Number of garbage bins associated with the building.
   *Antall søppelkasser tilknyttet bygningen* */
  numberOfGarbageBins?: number | null
  /** Number of pipes in the building.
   *Antall rør i bygningen* */
  numberOfPipes?: number | null
  /** Number of floors in the building.
   *Antall etasjer i bygningen* */
  numberOfFloors?: number | null
  /** Number of entrances in the building.
   *Antall innganger i bygningen* */
  numberOfEntrances?: number | null
  /** Year the building was constructed.
   *Byggeår* */
  builtYear?: number | null
  /** Date when the building was finished.
   *Ferdigstillelsesdato* */
  finishedDate?: string | null
  /** Type of facade for the building (joined from FASADETYPE).
   *Fasadetype (fra FASADETYPE)* */
  facadeType?: string | null
  /** Building class, e.g., fire class (joined from BYGNINGSKLASSE).
   *Bygningsklasse, f.eks. brannklasse (fra BYGNINGSKLASSE)* */
  buildingClass?: string | null
  /** Type of roof for the building (joined from TAKTYPE).
   *Taktype (fra TAKTYPE)* */
  roofType?: string | null
  /** Type of heating in the building (joined from OPPVARMINGSTYPE).
   *Oppvarmingstype (fra OPPVARMINGSTYPE)* */
  heating?: string | null
  /** Protection status of the building (from KODTAB_VERNESTATUS).
   *Vernestatus (fra KODTAB_VERNESTATUS)* */
  protectionStatus?: string | null
  /** Construction type or load-bearing system (from KONSTRUKSJONSTYPE).
   *Konstruksjonstype eller bæresystem (fra KONSTRUKSJONSTYPE)* */
  constructionType?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type BuildingType = {
  /** Name of the building type */
  type?: string | null
  /** Id of the building type */
  id?: number
}
export type BuildingClientClientIdBuildingtypesGet200TextPlainResponse =
  BuildingType[]
export type BblErrorItem = {
  id?: string | null
  message?: string | null
}
export type BblErrorModel = {
  /** What went wrong */
  errors?: BblErrorItem[] | null
  /** Stacktrace */
  stackTrace?: string | null
}
export type BuildingSingleResult = {
  /** Id of the building
   *Id på bygning* */
  id?: number
  /** Name of the building
   *Bygningsnavn* */
  name?: string | null
  /** Building type
   *Bygningstype* */
  buildingType?: string | null
  /** Building code
   *Bygningskode* */
  buildingCode?: string | null
  /** Addresses for a building */
  addresses?: BuildingAddressModel[] | null
  /** Number of units in building (andeler) */
  numberOfUnits?: number | null
}
export type BuildingForClientClientIdGet200TextPlainResponse =
  BuildingSingleResult[]
export type Unit = {
  /** Id of the Unit
   *Enhetsid* */
  id?: string | null
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** City
   *Poststed* */
  city?: string | null
  /** Country
   *Land* */
  country?: string | null
  /** Country code used by the norwegian tax directorate */
  countryCodeTaxDirectorate?: string | null
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit
   *Seksjonsnummer* */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit
   *Andelsnummer* */
  propertySectionNo?: string | null
  /** Gnr
   *Gårdsnummer* */
  gnr?: number | null
  /** Bnr
   *Bruksnummer* */
  bnr?: number | null
  /** GnrBnr Description
   *Beskrivelse av gårds- og bruksnummer* */
  gnrBnrDescription?: string | null
  /** Area: PrimaryRoom
   *Primærareal (P-rom)* */
  primaryRoom?: number | null
  /** Area: Use area
   *Bruksareal (Bra)* */
  useArea?: number | null
  /** Area: Living area
   *Boareal (Boa)* */
  livingArea?: number | null
  /** Area: Gross area
   *Bruttoareal (BTA)* */
  grossArea?: number | null
  /** Area: Net area
   *Nettoareal (NTA)* */
  netArea?: number | null
  /** Hba
   *Hba* */
  hba?: number | null
  /** Nla
   *Nla* */
  nla?: number | null
  /** Bra
   *bruksareal* */
  bra?: number | null
  /** BraI
   *BRA-i* */
  braI?: number | null
  /** BraE
   *BRA-e* */
  braE?: number | null
  /** BraB
   *BRA-b* */
  braB?: number | null
  /** AapentAreal
   *Åpent areal* */
  aapentAreal?: number | null
  /** Number of rooms
   *Antall rom* */
  numberOfRooms?: number | null
  /** Original number of rooms
   *Opprinnelig antall rom* */
  originalNumberOfRooms?: number | null
  /** Floor
   *Etasje* */
  floor?: string | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Buildingnumber
   *Bygningsnummer* */
  buildingNumber?: number | null
  /** Date of unit completion
   *Ferdigstilt dato* */
  completedDate?: string | null
  /** Clauses
   *Klausuler* */
  clauses?: string | null
  /** First date of use
   *Dato første innflytting* */
  firstUseDate?: string | null
  /** Tax value of the unit
   *Ligningsverdi* */
  taxValue?: number | null
  /** Unit type number
   *Enhetstypenummer* */
  unitTypeNumber?: number
  /** Unit type name
   *Enhetstypenavn* */
  unitTypeName?: string | null
  /** Category description
   *Kategoribetegnelse* */
  categoryDescription?: string | null
  /** Elevator
   *Heis* */
  elevator?: boolean
  /** Heating type number
   *Oppvarmingstypenummer* */
  heatingTypeNumber?: number | null
  /** Heating type
   *Oppvarmingstype* */
  heatingType?: string | null
  /** Parking type
   *Type parkering* */
  parkingType?: string | null
  /** Parking type description
   *Parkeringstype beskrivelse* */
  parkingTypeDescription?: string | null
  /** Parking spot number
   *Parkeringsplass nummer* */
  parkingSpotNumber?: string | null
  /** Property leasing number
   *Festenummer* */
  propertyLeasingNumber?: number | null
  /** Property shared number
   *Aksjeboenhetsnummer* */
  propertySharedNo?: string | null
  /** Client number
   *Klientnummer* */
  clientNo?: number
  /** Client Id (guid)
   *Klient id* */
  clientId?: string | null
  /** Property registration index
   *Gaard/bruksnummer indeks* */
  propertyRegistrationIndex?: number | null
  /** Unit index number
   *Enhetsindeksnummer* */
  unitIndex?: number | null
  /** Category index number
   *Kategoriindeksnummer* */
  categoryIndex?: number | null
  /** OBSOLETE: Use BuildingId
   *Utgår: Se BuildingId* */
  buildingIndex?: number
  /** Building address index number
   *Bygningsaddresseindeksnummer* */
  buildingAddressIndex?: number | null
  /** Latitude/longitude for address Sample:"59.1892046,11.1742115" */
  geoLocation?: string | null
  /** Parent Area Name
   *Overordnet område* */
  area?: string | null
  /** Area Name Id (ex: 1, 2, 3)
   *Områdenavn-id (bydels-id)* */
  subAreaId?: number | null
  /** Area Name (ex: Sagene, Kristiansand)
   *Områdenavn (bydelsnavn)* */
  subArea?: string | null
  /** BblCode of the house-building cooperative used by some APIs when house-building cooperatives have preemption partnership
   *BblCode som brukes ved GraphQL-resolving tilknyttet UnitType for felles forkjøpsrett* */
  houseBuildingCooperativeCode?: string | null
  /** UnitNumberDeveloper
   *Bolignummer utbygger* */
  unitNumberDeveloper?: string | null
  /** Property info
   *Gaardbruksnrinfo* */
  propertyInformation?: string | null
}
export type UnitRead = {
  /** Id of the Unit
   *Enhetsid* */
  id?: string | null
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** City
   *Poststed* */
  city?: string | null
  /** Country
   *Land* */
  country?: string | null
  /** Country code used by the norwegian tax directorate */
  countryCodeTaxDirectorate?: string | null
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit
   *Seksjonsnummer* */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit
   *Andelsnummer* */
  propertySectionNo?: string | null
  /** Gnr
   *Gårdsnummer* */
  gnr?: number | null
  /** Bnr
   *Bruksnummer* */
  bnr?: number | null
  /** GnrBnr Description
   *Beskrivelse av gårds- og bruksnummer* */
  gnrBnrDescription?: string | null
  /** Area: PrimaryRoom
   *Primærareal (P-rom)* */
  primaryRoom?: number | null
  /** Area: Use area
   *Bruksareal (Bra)* */
  useArea?: number | null
  /** Area: Living area
   *Boareal (Boa)* */
  livingArea?: number | null
  /** Area: Gross area
   *Bruttoareal (BTA)* */
  grossArea?: number | null
  /** Area: Net area
   *Nettoareal (NTA)* */
  netArea?: number | null
  /** Hba
   *Hba* */
  hba?: number | null
  /** Nla
   *Nla* */
  nla?: number | null
  /** Bra
   *bruksareal* */
  bra?: number | null
  /** BraI
   *BRA-i* */
  braI?: number | null
  /** BraE
   *BRA-e* */
  braE?: number | null
  /** BraB
   *BRA-b* */
  braB?: number | null
  /** AapentAreal
   *Åpent areal* */
  aapentAreal?: number | null
  /** Number of rooms
   *Antall rom* */
  numberOfRooms?: number | null
  /** Original number of rooms
   *Opprinnelig antall rom* */
  originalNumberOfRooms?: number | null
  /** Floor
   *Etasje* */
  floor?: string | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Id of the building */
  buildingId?: number
  /** Buildingnumber
   *Bygningsnummer* */
  buildingNumber?: number | null
  /** Date of unit completion
   *Ferdigstilt dato* */
  completedDate?: string | null
  /** Clauses
   *Klausuler* */
  clauses?: string | null
  /** First date of use
   *Dato første innflytting* */
  firstUseDate?: string | null
  /** Tax value of the unit
   *Ligningsverdi* */
  taxValue?: number | null
  /** Unit type number
   *Enhetstypenummer* */
  unitTypeNumber?: number
  /** Unit type name
   *Enhetstypenavn* */
  unitTypeName?: string | null
  /** Category description
   *Kategoribetegnelse* */
  categoryDescription?: string | null
  /** Elevator
   *Heis* */
  elevator?: boolean
  /** Heating type number
   *Oppvarmingstypenummer* */
  heatingTypeNumber?: number | null
  /** Heating type
   *Oppvarmingstype* */
  heatingType?: string | null
  /** Parking type
   *Type parkering* */
  parkingType?: string | null
  /** Parking type description
   *Parkeringstype beskrivelse* */
  parkingTypeDescription?: string | null
  /** Parking spot number
   *Parkeringsplass nummer* */
  parkingSpotNumber?: string | null
  /** Property leasing number
   *Festenummer* */
  propertyLeasingNumber?: number | null
  /** Property shared number
   *Aksjeboenhetsnummer* */
  propertySharedNo?: string | null
  /** Client number
   *Klientnummer* */
  clientNo?: number
  /** Client Id (guid)
   *Klient id* */
  clientId?: string | null
  /** Property registration index
   *Gaard/bruksnummer indeks* */
  propertyRegistrationIndex?: number | null
  /** Unit index number
   *Enhetsindeksnummer* */
  unitIndex?: number | null
  /** Category index number
   *Kategoriindeksnummer* */
  categoryIndex?: number | null
  /** OBSOLETE: Use BuildingId
   *Utgår: Se BuildingId* */
  buildingIndex?: number
  /** Building address index number
   *Bygningsaddresseindeksnummer* */
  buildingAddressIndex?: number | null
  /** Latitude/longitude for address Sample:"59.1892046,11.1742115" */
  geoLocation?: string | null
  /** Parent Area Name
   *Overordnet område* */
  area?: string | null
  /** Area Name Id (ex: 1, 2, 3)
   *Områdenavn-id (bydels-id)* */
  subAreaId?: number | null
  /** Area Name (ex: Sagene, Kristiansand)
   *Områdenavn (bydelsnavn)* */
  subArea?: string | null
  /** BblCode of the house-building cooperative used by some APIs when house-building cooperatives have preemption partnership
   *BblCode som brukes ved GraphQL-resolving tilknyttet UnitType for felles forkjøpsrett* */
  houseBuildingCooperativeCode?: string | null
  /** UnitNumberDeveloper
   *Bolignummer utbygger* */
  unitNumberDeveloper?: string | null
  /** Property info
   *Gaardbruksnrinfo* */
  propertyInformation?: string | null
}
export type HousingUnitsReturnModel = {
  /** List of units
   *List av enheter* */
  units?: Unit[] | null
}
export type HousingUnitsReturnModelRead = {
  /** List of units
   *List av enheter* */
  units?: UnitRead[] | null
  /** Number of results
   *Ante enheter i svar* */
  results?: number
}
export type BuildingClientClientIdPost200TextPlainResponse =
  BuildingSingleResult[]
export type BuildingQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** Name to search for, full or partial */
  name?: string | null
  /** Buildingtype to search for, full or partial */
  buildingType?: string | null
  /** Number of units to search for */
  numberOfUnits?: number | null
  sortColumn?: BuildingQuerySortColumn
}
export type ClientClientIdExportExcelPost200TextPlainResponse = Blob[]
export type UnitQueryExtension = {
  propertyType?: UnitListExtensionProperties
  /** For meters and objects, this will need to be specified to specify which type will be included. */
  propertyTypeValue?: number | null
  name?: string | null
  id?: string | null
}
export type UnitQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** BuildingAddress filter */
  addressId?: number | null
  sortColumn?: UnitQuerySortColumn
  /** Subleased true/false (null for both) */
  subleased?: boolean | null
  /** Include tenants in search result (default true) */
  includeTenants?: boolean
  /** Include proxy owners in search result (default false) */
  includeProxyOwners?: boolean
  extendedQuery?: UnitQueryExtension
}
export type UnitExportField = {
  id?: UnitExportFieldType
  /** Descriptive Text(norwegian), for UI use when selecting what to export */
  description?: string | null
  /** From metadata: Default selected or not. For Export: If the field should be included */
  selected?: boolean
}
export type UnitExportGroup = {
  id?: ExportGroupEnum
  /** Descriptive Text(norwegian), for UI use when selecting what to export */
  description?: string | null
  /** All fields in this group */
  fields?: UnitExportField[] | null
}
export type UnitExportSelectionModel = {
  /** All groups with fields */
  groups?: UnitExportGroup[] | null
  /** Random Pincode for use when protecting sheet. Use or create another */
  pin?: string | null
}
export type ExportRequestModel = {
  unitQuery?: UnitQueryModel
  exportDetails?: UnitExportSelectionModel
}
export type ClientClientIdQueryextensionsGet200TextPlainResponse =
  UnitQueryExtension[]
export type UnitIdentification = {
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit (*Seksjonsnummer*) */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit(*Andelsnummer*) */
  propertySectionNo?: string | null
  /** Bnr(*Bruksnummer*) */
  bnr?: number | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Property shared number(*Aksjeboenhetsnummer*) */
  propertySharedNo?: string | null
}
export type PersonDetails = {
  id?: string | null
  firstName?: string | null
  lastName?: string | null
  from?: string
  to?: string | null
}
export type UnitAddress = {
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** City
   *Poststed* */
  city?: string | null
  /** Unique id for address */
  addressId?: number
  country?: string | null
}
export type UnitBoardDetails = {
  created?: string
  createByUser?: string | null
  updated?: string
  updatedByUser?: string | null
  notes?: string | null
}
export type UnitQuerySingleResult = {
  /** Id of the Unit (*Enhetsid*) */
  id?: string | null
  identificationFields?: UnitIdentification
  /** Name of current tenants */
  tenants?: string[] | null
  tenantsDetails?: PersonDetails[] | null
  unitAddress?: UnitAddress
  /** Name of current owners */
  owners?: string[] | null
  ownersDetails?: PersonDetails[] | null
  /** ClientId */
  clientId?: string | null
  remainingJointDebtAmount?: number
  boardDetails?: UnitBoardDetails
  /** If unit is rented out */
  isSubleased?: boolean
  /** Optional column, specify in query. Date of start of ownership. */
  ownerSince?: string | null
  /** Optional column, specify in query. Returns objects of specified type in query connected to unit. */
  objectInfo?: string[] | null
  /** Optional column, specify in query. Returns meters of specified type in query connected to unit. */
  meterInfo?: string[] | null
  /** Optional column, specify in query. Returns unit number developer (bolignummer utbygger) */
  unitNumberDeveloper?: string | null
  /** Proxy owners */
  proxyOwners?: string[] | null
}
export type UnitQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: UnitQuerySingleResult[] | null
}
export type UnitQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: UnitQuerySingleResult[] | null
}
export type ClientClientIdAddressesGet200TextPlainResponse = UnitQueryResult[]
export type ClientClientIdAddressesGet200TextPlainResponseRead =
  UnitQueryResultRead[]
export type TenantQuerySingleResult = {
  /** Id of the Unit (*Enhetsid*) */
  id?: string | null
  identificationFields?: UnitIdentification
  /** Name of current tenants */
  tenants?: string[] | null
  tenantsDetails?: PersonDetails[] | null
  unitAddress?: UnitAddress
  /** Name of current owners */
  owners?: string[] | null
  ownersDetails?: PersonDetails[] | null
  /** ClientId */
  clientId?: string | null
  remainingJointDebtAmount?: number
}
export type TenantQuerySingleResultQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: TenantQuerySingleResult[] | null
}
export type TenantQuerySingleResultQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: TenantQuerySingleResult[] | null
}
export type TenantQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  sortColumn?: TenantQuerySortColumn
}
export type UnitQuerySingleResultQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: UnitQuerySingleResult[] | null
}
export type UnitQuerySingleResultQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: UnitQuerySingleResult[] | null
}
export type UnitUserQueryResult = {
  /** Navneregsiterid of the user. */
  nameId?: string | null
  referenceType?: UnitUserReferenceType
  /** Reference id (i.e. maaler id) */
  referenceId?: string | null
}
export type ClientClientIdUsersPost200TextPlainResponse = UnitUserQueryResult[]
export type UnitUsersQueryModel = {
  addressIds?: number[] | null
  objectIds?: string[] | null
  meterIds?: string[] | null
}
export type NavneregisterThirdpartyinformationIdDownloadGet200TextPlainResponse =
  Blob
export type InvoiceModel = {
  /** Unique identifier for invoice
   *KravId* */
  id?: number
  /** Invoice number
   *Fakturanummer* */
  invoiceNo?: number | null
  /** Date when invoice is due
   *Forfallsdato* */
  dueDate?: string
  /** Date when invoice is created
   *Fakturadato* */
  invoiceDate?: string | null
  /** Bank account number for invoice
   *Bankkontonr* */
  bankAccountNumber?: string | null
  /** Identification for customer
   *KId* */
  customerIdentificationId?: string | null
  /** Invoice type unique identifier
   *KravtypeId* */
  invoiceTypeId?: string | null
  /** Invoice type description
   *KravtypeTekst* */
  invoiceTypeDescription?: string | null
  /** Client number
   *Klientnr* */
  clientNo?: number
  /** Client name
    <i>KlientNavn</i> */
  clientName?: string | null
  /** Unique HF identifier
   *NavneId* */
  nameNo?: number
  /** Unique HF identifier
    <i>NavneId</i> */
  nameId?: string | null
  /** Full name of payer */
  fullName?: string | null
  /** Status of the invoice
   *Status* */
  status?: string | null
  /** Sum of original amount
   *Sum opprinnelig* */
  sumOriginalAmount?: number
  /** Sum of amount not paid
   *Sum ubetalt* */
  sumUnpaidAmount?: number
  /** Id of the Unit
   *Enhetsid* */
  housingUnitId?: string | null
  /** PrintMethod
   *Utskriftsmetode* */
  printMethod?: string | null
  /** Id of the client
   *forvaltningsklientid* */
  clientId?: string | null
  /** Set if invoice has been processed in multikanal */
  statusMultikanal?: string | null
  /** Online payment transaction
    <i>Betalt på nett</i> */
  onlinePaymentTransaction?: boolean
  /** Crossing number
    <i>Kryssenr</i> */
  crossingNumber?: number | null
}
export type NavneregisterInvoicesInvoiceIdFileGet200TextPlainResponse =
  InvoiceModel[]
export type NavneregisterInvoicesGet200TextPlainResponse = InvoiceModel[]
export type UnitWithRoleModel = {
  /** Id of the Unit
   *Enhetsid* */
  id?: string | null
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** City
   *Poststed* */
  city?: string | null
  /** Country
   *Land* */
  country?: string | null
  /** Country code used by the norwegian tax directorate */
  countryCodeTaxDirectorate?: string | null
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit
   *Seksjonsnummer* */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit
   *Andelsnummer* */
  propertySectionNo?: string | null
  /** Gnr
   *Gårdsnummer* */
  gnr?: number | null
  /** Bnr
   *Bruksnummer* */
  bnr?: number | null
  /** GnrBnr Description
   *Beskrivelse av gårds- og bruksnummer* */
  gnrBnrDescription?: string | null
  /** Area: PrimaryRoom
   *Primærareal (P-rom)* */
  primaryRoom?: number | null
  /** Area: Use area
   *Bruksareal (Bra)* */
  useArea?: number | null
  /** Area: Living area
   *Boareal (Boa)* */
  livingArea?: number | null
  /** Area: Gross area
   *Bruttoareal (BTA)* */
  grossArea?: number | null
  /** Area: Net area
   *Nettoareal (NTA)* */
  netArea?: number | null
  /** Hba
   *Hba* */
  hba?: number | null
  /** Nla
   *Nla* */
  nla?: number | null
  /** Bra
   *bruksareal* */
  bra?: number | null
  /** BraI
   *BRA-i* */
  braI?: number | null
  /** BraE
   *BRA-e* */
  braE?: number | null
  /** BraB
   *BRA-b* */
  braB?: number | null
  /** AapentAreal
   *Åpent areal* */
  aapentAreal?: number | null
  /** Number of rooms
   *Antall rom* */
  numberOfRooms?: number | null
  /** Original number of rooms
   *Opprinnelig antall rom* */
  originalNumberOfRooms?: number | null
  /** Floor
   *Etasje* */
  floor?: string | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Buildingnumber
   *Bygningsnummer* */
  buildingNumber?: number | null
  /** Date of unit completion
   *Ferdigstilt dato* */
  completedDate?: string | null
  /** Clauses
   *Klausuler* */
  clauses?: string | null
  /** First date of use
   *Dato første innflytting* */
  firstUseDate?: string | null
  /** Tax value of the unit
   *Ligningsverdi* */
  taxValue?: number | null
  /** Unit type number
   *Enhetstypenummer* */
  unitTypeNumber?: number
  /** Unit type name
   *Enhetstypenavn* */
  unitTypeName?: string | null
  /** Category description
   *Kategoribetegnelse* */
  categoryDescription?: string | null
  /** Elevator
   *Heis* */
  elevator?: boolean
  /** Heating type number
   *Oppvarmingstypenummer* */
  heatingTypeNumber?: number | null
  /** Heating type
   *Oppvarmingstype* */
  heatingType?: string | null
  /** Parking type
   *Type parkering* */
  parkingType?: string | null
  /** Parking type description
   *Parkeringstype beskrivelse* */
  parkingTypeDescription?: string | null
  /** Parking spot number
   *Parkeringsplass nummer* */
  parkingSpotNumber?: string | null
  /** Property leasing number
   *Festenummer* */
  propertyLeasingNumber?: number | null
  /** Property shared number
   *Aksjeboenhetsnummer* */
  propertySharedNo?: string | null
  /** Client number
   *Klientnummer* */
  clientNo?: number
  /** Client Id (guid)
   *Klient id* */
  clientId?: string | null
  /** Property registration index
   *Gaard/bruksnummer indeks* */
  propertyRegistrationIndex?: number | null
  /** Unit index number
   *Enhetsindeksnummer* */
  unitIndex?: number | null
  /** Category index number
   *Kategoriindeksnummer* */
  categoryIndex?: number | null
  /** OBSOLETE: Use BuildingId
   *Utgår: Se BuildingId* */
  buildingIndex?: number
  /** Building address index number
   *Bygningsaddresseindeksnummer* */
  buildingAddressIndex?: number | null
  /** Latitude/longitude for address Sample:"59.1892046,11.1742115" */
  geoLocation?: string | null
  /** Parent Area Name
   *Overordnet område* */
  area?: string | null
  /** Area Name Id (ex: 1, 2, 3)
   *Områdenavn-id (bydels-id)* */
  subAreaId?: number | null
  /** Area Name (ex: Sagene, Kristiansand)
   *Områdenavn (bydelsnavn)* */
  subArea?: string | null
  /** BblCode of the house-building cooperative used by some APIs when house-building cooperatives have preemption partnership
   *BblCode som brukes ved GraphQL-resolving tilknyttet UnitType for felles forkjøpsrett* */
  houseBuildingCooperativeCode?: string | null
  /** UnitNumberDeveloper
   *Bolignummer utbygger* */
  unitNumberDeveloper?: string | null
  /** Property info
   *Gaardbruksnrinfo* */
  propertyInformation?: string | null
  role?: HousingUnitRoles
}
export type UnitWithRoleModelRead = {
  /** Id of the Unit
   *Enhetsid* */
  id?: string | null
  /** Unit address
   *Addresse* */
  address?: string | null
  /** Address zipcode
   *Postnummer* */
  zip?: string | null
  /** City
   *Poststed* */
  city?: string | null
  /** Country
   *Land* */
  country?: string | null
  /** Country code used by the norwegian tax directorate */
  countryCodeTaxDirectorate?: string | null
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit
   *Seksjonsnummer* */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit
   *Andelsnummer* */
  propertySectionNo?: string | null
  /** Gnr
   *Gårdsnummer* */
  gnr?: number | null
  /** Bnr
   *Bruksnummer* */
  bnr?: number | null
  /** GnrBnr Description
   *Beskrivelse av gårds- og bruksnummer* */
  gnrBnrDescription?: string | null
  /** Area: PrimaryRoom
   *Primærareal (P-rom)* */
  primaryRoom?: number | null
  /** Area: Use area
   *Bruksareal (Bra)* */
  useArea?: number | null
  /** Area: Living area
   *Boareal (Boa)* */
  livingArea?: number | null
  /** Area: Gross area
   *Bruttoareal (BTA)* */
  grossArea?: number | null
  /** Area: Net area
   *Nettoareal (NTA)* */
  netArea?: number | null
  /** Hba
   *Hba* */
  hba?: number | null
  /** Nla
   *Nla* */
  nla?: number | null
  /** Bra
   *bruksareal* */
  bra?: number | null
  /** BraI
   *BRA-i* */
  braI?: number | null
  /** BraE
   *BRA-e* */
  braE?: number | null
  /** BraB
   *BRA-b* */
  braB?: number | null
  /** AapentAreal
   *Åpent areal* */
  aapentAreal?: number | null
  /** Number of rooms
   *Antall rom* */
  numberOfRooms?: number | null
  /** Original number of rooms
   *Opprinnelig antall rom* */
  originalNumberOfRooms?: number | null
  /** Floor
   *Etasje* */
  floor?: string | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Id of the building */
  buildingId?: number
  /** Buildingnumber
   *Bygningsnummer* */
  buildingNumber?: number | null
  /** Date of unit completion
   *Ferdigstilt dato* */
  completedDate?: string | null
  /** Clauses
   *Klausuler* */
  clauses?: string | null
  /** First date of use
   *Dato første innflytting* */
  firstUseDate?: string | null
  /** Tax value of the unit
   *Ligningsverdi* */
  taxValue?: number | null
  /** Unit type number
   *Enhetstypenummer* */
  unitTypeNumber?: number
  /** Unit type name
   *Enhetstypenavn* */
  unitTypeName?: string | null
  /** Category description
   *Kategoribetegnelse* */
  categoryDescription?: string | null
  /** Elevator
   *Heis* */
  elevator?: boolean
  /** Heating type number
   *Oppvarmingstypenummer* */
  heatingTypeNumber?: number | null
  /** Heating type
   *Oppvarmingstype* */
  heatingType?: string | null
  /** Parking type
   *Type parkering* */
  parkingType?: string | null
  /** Parking type description
   *Parkeringstype beskrivelse* */
  parkingTypeDescription?: string | null
  /** Parking spot number
   *Parkeringsplass nummer* */
  parkingSpotNumber?: string | null
  /** Property leasing number
   *Festenummer* */
  propertyLeasingNumber?: number | null
  /** Property shared number
   *Aksjeboenhetsnummer* */
  propertySharedNo?: string | null
  /** Client number
   *Klientnummer* */
  clientNo?: number
  /** Client Id (guid)
   *Klient id* */
  clientId?: string | null
  /** Property registration index
   *Gaard/bruksnummer indeks* */
  propertyRegistrationIndex?: number | null
  /** Unit index number
   *Enhetsindeksnummer* */
  unitIndex?: number | null
  /** Category index number
   *Kategoriindeksnummer* */
  categoryIndex?: number | null
  /** OBSOLETE: Use BuildingId
   *Utgår: Se BuildingId* */
  buildingIndex?: number
  /** Building address index number
   *Bygningsaddresseindeksnummer* */
  buildingAddressIndex?: number | null
  /** Latitude/longitude for address Sample:"59.1892046,11.1742115" */
  geoLocation?: string | null
  /** Parent Area Name
   *Overordnet område* */
  area?: string | null
  /** Area Name Id (ex: 1, 2, 3)
   *Områdenavn-id (bydels-id)* */
  subAreaId?: number | null
  /** Area Name (ex: Sagene, Kristiansand)
   *Områdenavn (bydelsnavn)* */
  subArea?: string | null
  /** BblCode of the house-building cooperative used by some APIs when house-building cooperatives have preemption partnership
   *BblCode som brukes ved GraphQL-resolving tilknyttet UnitType for felles forkjøpsrett* */
  houseBuildingCooperativeCode?: string | null
  /** UnitNumberDeveloper
   *Bolignummer utbygger* */
  unitNumberDeveloper?: string | null
  /** Property info
   *Gaardbruksnrinfo* */
  propertyInformation?: string | null
  role?: HousingUnitRoles
}
export type HousingUnitRoleReturnModel = {
  /** List of units
   *List av enheter* */
  units?: UnitWithRoleModel[] | null
}
export type HousingUnitRoleReturnModelRead = {
  /** List of units
   *List av enheter* */
  units?: UnitWithRoleModelRead[] | null
  /** Number of results
   *Ante enheter i svar* */
  results?: number
}
export type ThirdPartyInformationModel = {
  /** Id of the third party information entry
   *Id på tredjepartsopplysningen (ligningsoppgaven)* */
  id?: number
  /** Year for this this party information
   *Ligningsår* */
  year?: number
  /** The time this entry was registered
   *Registrert* */
  registered?: string | null
  /** Id of the unit
   *Id på enhet* */
  unitId?: string | null
  /** Indicates if the PDF is ready for download
   *Pdf klar for nedlasting* */
  availableForDownload?: boolean
  /** Client number
   *Klientnummer* */
  clientNo?: number | null
  /** Unit number
   *Enhetetsnummer */
  unitNo?: number | null
}
export type ThirdPartyInformationModelRead = {
  /** Id of the third party information entry
   *Id på tredjepartsopplysningen (ligningsoppgaven)* */
  id?: number
  /** Year for this this party information
   *Ligningsår* */
  year?: number
  /** The time this entry was registered
   *Registrert* */
  registered?: string | null
  /** Id of the unit
   *Id på enhet* */
  unitId?: string | null
  /** Address of the unit
   *Enhetsadresse* */
  unitAddress?: string | null
  /** Indicates if the PDF is ready for download
   *Pdf klar for nedlasting* */
  availableForDownload?: boolean
  /** Entry is read by the owner */
  isRead?: boolean
  /** Client number
   *Klientnummer* */
  clientNo?: number | null
  /** Unit number
   *Enhetetsnummer */
  unitNo?: number | null
}
export type NavneregisterThirdpartyinformationGet200TextPlainResponse =
  ThirdPartyInformationModel[]
export type NavneregisterThirdpartyinformationGet200TextPlainResponseRead =
  ThirdPartyInformationModelRead[]
export type EnhetNavnReltype = {
  id?: number
  beskrivelse?: string | null
  overfoerBolig?: number | null
}
export type UnitRelationtypesGet200TextPlainResponse = EnhetNavnReltype[]
export type AdditionalInfoForUnitModel = {
  /** Id of the additional information */
  id?: string | null
  /** Id of the unit this information is related to */
  unitId?: string | null
  /** The information text */
  text?: string | null
  /** Sorting order for the information text when part of a list */
  sortOrder?: number
}
export type UnitIdAdditionalinfoGet200TextPlainResponse =
  AdditionalInfoForUnitModel[]
export type UnitIdIsaffiliatedGet200TextPlainResponse = boolean
export type UnitIdHascoownerprocessGet200TextPlainResponse = boolean
export type CoResidentCreateModel = {
  /** Firstname of co resident */
  firstName?: string | null
  /** Lastname of co resident */
  lastName?: string | null
  /** Phonenumber of co resident */
  phoneNumber?: string | null
  /** Email of co resident */
  email?: string | null
  /** Birthdate of co resident */
  birthDate?: string
  /** Residency type */
  relationType?: number
}
export type CoResidentModel = {
  /** Co residency id (not nameId) */
  id?: string | null
  /** Firstname of co resident */
  firstName?: string | null
  /** Lastname of co resident */
  lastName?: string | null
  /** Phonenumber of co resident */
  phoneNumber?: string | null
  /** Email of co resident */
  email?: string | null
  /** Co resident unique person id */
  nameId?: string | null
  /** Name number */
  nameNo?: number
  /** Birthdate of co resident */
  birthDate?: string | null
  /** Full name */
  name?: string | null
  /** Residency type description */
  type?: string | null
  /** Type id */
  typeId?: number
  /** User has logged in
   *HasCreatedLogin bestemmes kun av om brukeren har en rad i MappingUsersNavn eller ikke (uten tilleggssjekk på bekreftet e-postadresse eller mobilnr)* */
  hasCreatedLogin?: boolean
}
export type UnitIdResidentsGet200TextPlainResponse = CoResidentModel[]
export type CoResidentUpdateModel = {
  /** Phonenumber of co-resident */
  phoneNumber?: string | null
  /** Email of co-resident */
  email?: string | null
  /** Relation type */
  relationType?: number
}
export type UnitIdInvoicesInvoiceIdFileGet200TextPlainResponse = InvoiceModel[]
export type AddressResponse = {
  line1?: string | null
  line2?: string | null
  line3?: string | null
  zip?: string | null
  city?: string | null
  country?: string | null
  countryCode?: string | null
}
export type UnitOwnerModel = {
  /** NavneregisterId */
  id?: string | null
  /** Name number */
  nameNo?: number
  /** Unit owner index number */
  unitOwnerIndex?: number
  /** Owner from date */
  ownerFrom?: string
  /** Owner to date */
  ownerTo?: string | null
  /** Users birthdate */
  birthDate?: string | null
  /** First and middle name */
  firstName?: string | null
  /** Surname /lastname */
  lastName?: string | null
  /** Phone number. If juridical person, gets tlfjobb, otherwise tlfmobil. */
  phoneNumber?: string | null
  /** Email */
  email?: string | null
  /** Indicates whether the owner is a payer for this unit */
  isPayer?: boolean
  /** Indicates whether the owner is a contact for this unit */
  isContact?: boolean
  address?: AddressResponse
  /** Returns true if user is registered in BBLiD or other relevant identification provider. */
  hasCreatedLogin?: boolean
  /** True if the user has a valid SSN */
  hasValidSsn?: boolean
  /** SSN (fødsel- og personnummer) */
  ssn?: string | null
  /** Ownership percentage */
  ownershipPercentage?: number
  /** Ownership fraction numerator */
  ownershipFractionNumerator?: number | null
}
export type UnitIdOwnersGet200TextPlainResponse = UnitOwnerModel[]
export type AnnualCycleTaskModel = {
  /** Id of the task
   *Id på oppgaven* */
  id?: string | null
  /** Title of the task
   *Oppgavens tittel* */
  title?: string | null
  /** Description of the task
   *Beskrivelse av oppgave* */
  description?: string | null
  /** Deadline of the task
   *Frist for utførelse av oppgave* */
  deadline?: string
  /** Frequency in months
   *Oppgavens frekvens* */
  frequencyInMonths?: number
  /** Task is visible to residents
   *Oppgave synlig for beboere* */
  visibleForResidents?: boolean
  /** NameRegistry Id of user that created this task
   *NavneregisterId til bruker som opprettet oppgaven* */
  createdBy?: string | null
}
export type AnnualCycleModel = {
  /** List of tasks for the cycle
   *Liste med oppgaver for året* */
  tasks?: AnnualCycleTaskModel[] | null
}
export type MeterModel = {
  /** Id of the meter
   *Måler-id* */
  id?: number
  /** Name of the meter
   *Måler-betegnelse* */
  name?: string | null
  /** Type of the meter
   *Betegnelse for målertypen* */
  type?: string | null
}
export type UnitIdMetersGet200TextPlainResponse = MeterModel[]
export type NoteUpdateModel = {
  /** Note */
  notes?: string | null
  /** Updated by user */
  updatedBy?: string | null
}
export type ObjectModel = {
  /** Id of the object
   *Objekt-id* */
  id?: string | null
  /** Name of the object
   *Objekt-betegnelse* */
  name?: string | null
  /** Type of the object
   *Portal-betegnelse, eller betegnelse, for objekttypen* */
  type?: string | null
}
export type UnitIdObjectsGet200TextPlainResponse = ObjectModel[]
export type UnitIdProxyownerGet200TextPlainResponse = UnitOwnerModel[]
export type UnitIdInvoicesGet200TextPlainResponse = InvoiceModel[]
export type JointCostModel = {
  /** Name of the expense
   *Navn på utgift* */
  name?: string | null
  /** Sum of the expense
   *Utgiftssum* */
  sum?: number
}
export type JointCostMonthModel = {
  /** Represent the month in number (1 = January)
   *Månedsnummer* */
  month?: number
  /** Represents the year in number
   *Årstall* */
  year?: number
  /** Name of the month (in english)
   *Månedsnavn* */
  monthName?: string | null
  /** Total sum of the costs
   *Total kostnadssum* */
  sum?: number
  /** Detailed list of expenses
   *Detaljert liste med utgifter* */
  expenses?: JointCostModel[] | null
}
export type UnitIdJointcostGet200TextPlainResponse = JointCostMonthModel[]
export type UnitIdJointcostpersonalGet200TextPlainResponse =
  JointCostMonthModel[]
export type CoOwnerParametersModel = {
  /** True if hf-parameter 'FjernLeggTilMedeierMinSide' is set. */
  fjernLeggTilMedeierMinSideSalgsoppdragstypeOk?: boolean
  /** True if hf-parameter 'FjernLeggTilMedeierMinSideVaregruppe' is set and 'varegruppe har varer med pris'. */
  fjernLeggTilMedeierMinSideVaregruppeOk?: boolean
  /** True if hf-parameter 'FjernDødMedeierMinSide' is set. */
  fjernDoedMedeierMinSideSalgsoppdragstypeOk?: boolean
  /** True if hf-parameter 'FjernDødMedeierMinSideVaregruppe' is set and 'varegruppe har varer med pris'. */
  fjernDoedMedeierMinSideVaregruppeOk?: boolean
  /** True if hf-parameter 'OverførBolig' is set. */
  overfoerBoligSalgsoppdragstypeOk?: boolean
  /** True if hf-parameter 'OverførBoligVaregruppe' is set and 'varegruppe har varer med pris'. */
  overfoerBoligVaregruppeOk?: boolean
  /** If FjernLeggTilMedeierMinSideVaregruppeOk is true, this is the price for adding or removing a co-owner. Else it is null. */
  changeCoOwnerPrice?: number | null
  /** If FjernDoedMedeierMinSideVaregruppeOk is true, this is the price for removing a deceased co-owner. Else it is null. */
  changeCoOwnerDeceasedPrice?: number | null
  /** if OverfoerBoligVaregruppeOk is true, this is the price for adding or removing a co-owner. Else it is null. */
  transferUnitPrice?: number | null
  /** True if hf-parameter 'VisToAarssjekkLeggTilMedeier' is set to 'J'. */
  showTwoYearsResidencyQuestion?: boolean
}
export type UnitIdOwnersHistoricalGet200TextPlainResponse = MeterModel[]
export type UnitIsssnvalidSsnGet200TextPlainResponse = boolean
export type Areas = {
  /** Total site area */
  totalForSite?: number
  /** Area allowed for use */
  forUse?: number
  /** Area used /built */
  used?: number
}
export type SiteDetail = {
  /** Id of the site
   *Id på bygning* */
  id?: number
  /** Site description
   *Bygningsnavn* */
  description?: string | null
  /** GardsNr */
  gNo?: number | null
  /** BruksNr */
  bNo?: number | null
  /** Seksjonsnr */
  sectionNo?: string | null
  /** True if site is owned */
  isOwned?: boolean
  gNoBNo?: string | null
  areas?: Areas
  /** Estimated value/rate for site
    NO: Eiendomstakst */
  siteRate?: number
  owner?: string | null
  notes?: string | null
  /** NO: Festeavgift */
  leasingFee?: number
  /** Contract expiry date */
  expires?: string | null
  /** Contract start date */
  started?: string | null
  /** Date for possible buyout for leased site
    NO: Mulig innløsning */
  possibleBuyout?: string | null
  /** NO: Antall år mellom hver gang festeavgiften kan justeres */
  yearsBetweenLeasingFeeAdjustment?: number | null
  /** If leased, this points to the owner */
  supplierId?: number
}
export type SiteSingleResult = {
  /** Id of the site
   *Id på bygning* */
  id?: number
  /** Site description
   *Bygningsnavn* */
  description?: string | null
  /** GardsNr */
  gNo?: number | null
  /** BruksNr */
  bNo?: number | null
  /** Seksjonsnr */
  sectionNo?: string | null
  /** True if site is owned */
  isOwned?: boolean
  gNoBNo?: string | null
}
export type SiteClientClientIdPost200TextPlainResponse = SiteSingleResult[]
export type SiteQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  sortColumn?: SiteQuerySortColumn
}
export type TenantModel = {
  /** Tenancy id. Unique reference to tenancy */
  id?: number
  /** Firstname of tenant */
  firstName?: string | null
  /** Lastname of tenant */
  lastName?: string | null
  /** Phonenumber of tenant */
  phoneNumber?: string | null
  /** Email of tenant */
  email?: string | null
  /** Tenant unique person id */
  nameId?: string | null
  /** Name number */
  nameNo?: number
  /** Birthdate of tenant */
  birthDate?: string | null
  /** Is tenant from */
  tenantFrom?: string
  /** Is tenant to */
  tenantTo?: string | null
  /** Full name */
  name?: string | null
}
export type UnitUnitIdTenantsGet200TextPlainResponse = TenantModel[]
export type TenantsUpdateModel = {
  /** Tenancy id. Unique reference to tenancy */
  id?: number
  /** New date for tenancy */
  tenantTo?: string | null
}
export type PeriodModel = {
  /** Start of period. Required */
  from?: string
  /** End of period. May be null/open */
  to?: string | null
}
export type UnitUnitIdTenantsHistoricalGet200TextPlainResponse = PeriodModel[]
export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
export enum BuildingQuerySortColumn {
  Name = 'Name',
  BuildingType = 'BuildingType',
  NumberOfUnits = 'NumberOfUnits',
}
export enum UnitQuerySortColumn {
  ShareOrSectionNumber = 'ShareOrSectionNumber',
  UnitAddress = 'UnitAddress',
  SsbNumber = 'SsbNumber',
  RentedOut = 'RentedOut',
  PropertyNumber = 'PropertyNumber',
  OwnerSince = 'OwnerSince',
  Objects = 'Objects',
  Meters = 'Meters',
  UnitNumberDeveloper = 'UnitNumberDeveloper',
  RemainingJointDebtAmount = 'RemainingJointDebtAmount',
}
export enum UnitListExtensionProperties {
  OwnerSince = 'OwnerSince',
  Objects = 'Objects',
  Meters = 'Meters',
  UnitNumberDeveloper = 'UnitNumberDeveloper',
  RemainingJointDebtAmount = 'RemainingJointDebtAmount',
}
export enum ExportGroupEnum {
  Unit = 'Unit',
  Owner = 'Owner',
  Economy = 'Economy',
  Building = 'Building',
  OtherResidents = 'OtherResidents',
}
export enum UnitExportFieldType {
  UnitPropertyNo = 'UnitPropertyNo',
  UnitNumber = 'UnitNumber',
  UnitAddress = 'UnitAddress',
  UnitSectionNo = 'UnitSectionNo',
  UnitArea = 'UnitArea',
  UnitNumberOfRooms = 'UnitNumberOfRooms',
  UnitCategory = 'UnitCategory',
  UnitInfo = 'UnitInfo',
  OwnerName = 'OwnerName',
  OwnerBirthDate = 'OwnerBirthDate',
  OwnerPhone = 'OwnerPhone',
  OwnerEmail = 'OwnerEmail',
  OwnerAddress = 'OwnerAddress',
  ReservationECom = 'ReservationECom',
  OwnerSince = 'OwnerSince',
  JuridicalOwner = 'JuridicalOwner',
  ProxyOwner = 'ProxyOwner',
  PartOfCommonDebt = 'PartOfCommonDebt',
  Distribution = 'Distribution',
  CommonCosts = 'CommonCosts',
  LatestTransactionAmount = 'LatestTransactionAmount',
  BuildingInformation = 'BuildingInformation',
  Tenants = 'Tenants',
  CoResidents = 'CoResidents',
}
export enum TenantQuerySortColumn {
  PropertyNumber = 'PropertyNumber',
  ShareOrSectionNumber = 'ShareOrSectionNumber',
  Tenants = 'Tenants',
  Address = 'Address',
  Owners = 'Owners',
}
export enum UnitUserReferenceType {
  Address = 'Address',
  Meter = 'Meter',
  Object = 'Object',
}
export enum HousingUnitRoles {
  Eier = 'Eier',
  Fullmaktshaver = 'Fullmaktshaver',
  Leietaker = 'Leietaker',
  Beboer = 'Beboer',
}
export enum SiteQuerySortColumn {
  Gnr = 'Gnr',
  Bnr = 'Bnr',
  SectionNo = 'SectionNo',
  IsOwned = 'IsOwned',
}
export const {
  useGetBuildingByBuildingIdQuery,
  useGetBuildingClientByClientIdBuildingtypesQuery,
  useGetBuildingForClientByClientIdQuery,
  useGetBuildingByBuildingIdUnitsQuery,
  usePostBuildingClientByClientIdQuery,
  usePostClientByClientIdExportExcelMutation,
  useGetClientByClientIdQueryextensionsQuery,
  useGetClientByClientIdAddressesQuery,
  useGetClientByClientIdExportMetadataQuery,
  usePostClientByClientIdTenantsQuery,
  usePostClientByClientIdUnitsQuery,
  usePostClientByClientIdUsersMutation,
  useGetNavneregisterThirdpartyinformationByIdDownloadQuery,
  useGetNavneregisterInvoicesByInvoiceIdFileQuery,
  useGetNavneregisterInvoicesQuery,
  useGetNavneregisterUnitsQuery,
  useGetNavneregisterThirdpartyinformationQuery,
  useGetUnitRelationtypesQuery,
  useGetUnitByIdAdditionalinfoQuery,
  usePostUnitByIdCoownersMutation,
  useGetUnitByIdIsaffiliatedQuery,
  useGetUnitByIdHascoownerprocessQuery,
  usePostUnitByIdResidentsMutation,
  useGetUnitByIdResidentsQuery,
  useDeleteUnitByIdResidentsAndCoResidencyIdMutation,
  usePutUnitByIdResidentsAndCoResidencyIdMutation,
  useGetUnitByIdInvoicesAndInvoiceIdFileQuery,
  useGetUnitByIdOwnersQuery,
  useGetUnitByIdQuery,
  useGetUnitByIdAnnualcycleQuery,
  useGetUnitByIdMetersQuery,
  useGetUnitByIdNotesQuery,
  usePutUnitByIdNotesMutation,
  useGetUnitByIdObjectsQuery,
  useGetUnitByIdProxyownerQuery,
  useGetUnitByIdInvoicesQuery,
  useGetUnitByIdJointcostQuery,
  useGetUnitByIdJointcostpersonalQuery,
  useGetUnitChangecoownerparametersQuery,
  useGetUnitByIdOwnersHistoricalQuery,
  useGetUnitIsssnvalidBySsnQuery,
  useGetSiteSiteBySiteIdQuery,
  usePostSiteClientByClientIdMutation,
  useGetUnitByUnitIdTenantsQuery,
  usePutUnitByUnitIdTenantsMutation,
  useGetUnitByUnitIdTenantsHistoricalQuery,
} = injectedRtkApi
